import { WarningFilled } from '@ant-design/icons';
import { Row, Space } from 'antd';

import { Button, Modal } from '..';

type ModalRemoveStopoverOmissionProps = {
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
  vesselName: string;
  stopoverId: number | undefined;
  removeOmissionConfirm: (id: number) => void | Promise<void>;
  isLoading?: boolean;
};

export function ModalRemoveStopoverOmission(
  props: ModalRemoveStopoverOmissionProps
) {
  const {
    showModal,
    setShowModal,
    vesselName,
    stopoverId,
    removeOmissionConfirm,
    isLoading,
  } = props;

  function handleRemoveOmission() {
    if (stopoverId) {
      removeOmissionConfirm(stopoverId);
    }
    setShowModal(false);
  }

  return (
    <Modal
      visible={showModal}
      className="TOSWarningModal"
      width={520}
      title={
        <>
          <WarningFilled /> Atenção
        </>
      }
      onCancel={() => setShowModal(false)}
      footer={null}
    >
      <>
        <p>
          Tem certeza de que deseja remover a omissão de {vesselName}? O motivo
          informado será apagado e a escala voltará a ser operada normalmente.
        </p>
        <Row justify="end">
          <Space size={12}>
            <Button onClick={() => setShowModal(false)}>Voltar</Button>
            <Button
              danger
              loading={isLoading}
              onClick={() => handleRemoveOmission()}
            >
              Remover omissão
            </Button>
          </Space>
        </Row>
      </>
    </Modal>
  );
}
